import { render, staticRenderFns } from "./UserMainPage.vue?vue&type=template&id=0e6c85ae&scoped=true&"
import script from "./UserMainPage.vue?vue&type=script&lang=js&"
export * from "./UserMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c85ae",
  null
  
)

export default component.exports